var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTedLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 88,
    viewBox: "0 0 231 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_201_252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2784 35.3821V30.8182H51.7812V35.3821H43.7656V57H38.294V35.3821H30.2784ZM55.3224 57V30.8182H72.9645V35.3821H60.858V41.6207H72.0568V46.1847H60.858V52.4361H73.0156V57H55.3224ZM86.6467 57H77.3654V30.8182H86.7234C89.3569 30.8182 91.6239 31.3423 93.5245 32.3906C95.4251 33.4304 96.8867 34.9261 97.9094 36.8778C98.9407 38.8295 99.4563 41.1648 99.4563 43.8835C99.4563 46.6108 98.9407 48.9545 97.9094 50.9148C96.8867 52.875 95.4165 54.3793 93.4989 55.4276C91.5898 56.4759 89.3058 57 86.6467 57ZM82.9009 52.2571H86.4165C88.0529 52.2571 89.4293 51.9673 90.5458 51.3878C91.6708 50.7997 92.5146 49.892 93.0771 48.6648C93.6481 47.429 93.9336 45.8352 93.9336 43.8835C93.9336 41.9489 93.6481 40.3679 93.0771 39.1406C92.5146 37.9134 91.6751 37.0099 90.5586 36.4304C89.4421 35.8509 88.0657 35.5611 86.4293 35.5611H82.9009V52.2571Z",
    fill: "#F10000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.734 57H118.802L127.84 30.8182H134.974L143.999 57H138.067L131.509 36.8011H131.305L124.734 57ZM124.363 46.7088H138.374V51.0298H124.363V46.7088ZM169.021 39.9844H163.422C163.319 39.2599 163.11 38.6165 162.795 38.054C162.48 37.483 162.075 36.9972 161.581 36.5966C161.086 36.196 160.515 35.8892 159.868 35.6761C159.228 35.4631 158.534 35.3565 157.784 35.3565C156.429 35.3565 155.248 35.6932 154.243 36.3665C153.237 37.0312 152.457 38.0028 151.903 39.2812C151.349 40.5511 151.072 42.0937 151.072 43.9091C151.072 45.7756 151.349 47.3437 151.903 48.6136C152.466 49.8835 153.25 50.8423 154.255 51.4901C155.261 52.1378 156.424 52.4616 157.745 52.4616C158.487 52.4616 159.173 52.3636 159.804 52.1676C160.443 51.9716 161.01 51.6861 161.504 51.3111C161.998 50.9276 162.407 50.4631 162.731 49.9176C163.064 49.3722 163.294 48.75 163.422 48.0511L169.021 48.0767C168.876 49.2784 168.514 50.4375 167.934 51.554C167.363 52.6619 166.592 53.6548 165.62 54.5327C164.657 55.402 163.507 56.0923 162.169 56.6037C160.839 57.1065 159.335 57.358 157.656 57.358C155.321 57.358 153.233 56.8295 151.392 55.7727C149.559 54.7159 148.11 53.1861 147.045 51.1832C145.988 49.1804 145.46 46.7557 145.46 43.9091C145.46 41.054 145.997 38.625 147.071 36.6222C148.145 34.6193 149.602 33.0937 151.443 32.0455C153.284 30.9886 155.355 30.4602 157.656 30.4602C159.173 30.4602 160.579 30.6733 161.875 31.0994C163.179 31.5256 164.333 32.1477 165.339 32.9659C166.345 33.7756 167.163 34.7685 167.794 35.9446C168.433 37.1207 168.842 38.4673 169.021 39.9844ZM172.99 57V30.8182H190.632V35.3821H178.526V41.6207H189.725V46.1847H178.526V52.4361H190.684V57H172.99Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.148 31.4545L112.081 36.4119H112.195L115.142 31.4545H118.615L114.176 38.7273L118.714 46H115.178L112.195 41.0355H112.081L109.098 46H105.575L110.128 38.7273L105.661 31.4545H109.148Z",
    fill: "#F10000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_201_252",
    x: 0.278412,
    y: 0.460449,
    width: 220.405,
    height: 86.8975,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_201_252"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_201_252",
    result: "effect2_dropShadow_201_252"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_201_252",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTedLogo);
export default __webpack_public_path__ + "static/media/TEDLogo.d8294f355b1eb8639ebe29f30c69a0bc.svg";
export { ForwardRef as ReactComponent };